import React, { useState, useEffect, useCallback } from "react";

const LinkContext = React.createContext([{}, () => {}]);

const LinkProvider = (props) => {
  const [ws, setWS] = useState(null);
  const [wsStatus, setWSStatus] = useState(-1);
  const [viz, setViz] = useState([]);
  const [commands, setCommands] = useState([]);
  useEffect(() => {
    connect();
  }, []);

  function connect() {
    console.log("connecting to link server");
    try {
      let ws_string = "wss://";
      if (window.location.protocol === "http:") {
        ws_string = "ws://";
      }

      window.ws = new WebSocket(ws_string + window.location.hostname);
      setWS(window.ws);
    } catch (err) {}
  }

  useEffect(() => {
    if (window.ws) {
      let timeout;
      window.ws.onopen = () => {
        setWSStatus(1);
        console.log("Hyper Link on open");
        clearInterval(window.keep_alive);
        window.keep_alive = setInterval(() => {
          window.ws.send(
            JSON.stringify({
              keep_alive: Date.now(),
              group: window.id,
            })
          );
        }, 20000);
      };

      window.ws.onerror = (err) => {
        console.log("Link on message", err);
        ws.close();
      };
      window.ws.onclose = (data) => {
        setWSStatus(0);
        console.log("Link on close");
        clearTimeout(timeout);
        clearInterval(window.keep_alive);
        timeout = setTimeout(() => {
          connect();
        }, 1000);
      };
    }
  }, [ws]);

  useEffect(() => {
    if (window.ws) {
      window.ws.onmessage = (data) => {
        //console.log("Clock on message");
        try {
          let obj = JSON.parse(data.data);

          if (!obj.keep_alive) {
            if (obj.type === "viz-list") {
              setViz(obj.data);
            }
            if (obj.type === "viz-update") {
              let new_list = [...viz];
              new_list = new_list?.filter((v) => v?.ip !== obj.data.ip);
              new_list.push(obj.data);
              setViz(new_list);
            }
            if (obj.type === "viz-command") {
              let new_commands = [...commands];
              new_commands.push(obj.data);
              setCommands(new_commands);
            }
          }

          //console.log(obj);
        } catch (err) {
          console.error(err);
        }
      };
    }
  }, [ws, viz, commands]);

  return (
    <LinkContext.Provider
      value={{
        wsStatus,
        viz,
        commands,
      }}
    >
      {props.children}
    </LinkContext.Provider>
  );
};

export { LinkContext, LinkProvider };
